import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import styles from '@/app/cc/_component/ui/section/RiskDiagnosis/RiskDiagnosis.module.scss';
export interface RiskCardProps {
  readonly info: string;
  readonly title: string;
  readonly description1: string;
  readonly description2: string;
  readonly description3: string;
  readonly icon: string;
  readonly image: {
    readonly src: string;
    readonly alt: string;
  };
}
export default function RiskCard(t0) {
  const $ = _c(32);
  const {
    info,
    title,
    description1,
    description2,
    description3,
    icon,
    image
  } = t0;
  let t1;
  if ($[0] !== info) {
    t1 = <p className={styles.riskCardInfo}>{info}</p>;
    $[0] = info;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h4 className={styles.riskCardTitleText}>{title}</h4>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <header className={styles.riskCardHeader}>{t1}{t2}</header>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== image.src) {
    t4 = <div className={styles.riskCardAvatar} aria-hidden="true"><div className={styles.riskCardAvatarInner}><Image src={image.src} alt="" fill={true} sizes="(max-width: 1200px) 30vw, 10rem" /></div></div>;
    $[7] = image.src;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className={styles.riskCardTop}>{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== description1) {
    t6 = <p className={styles.riskCardSubject}>{description1}</p>;
    $[12] = description1;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== description2) {
    t7 = description2.split(/\n\n+/).map(_temp).filter(Boolean).map(_temp2);
    $[14] = description2;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <div className={styles.riskCardStory}>{t7}</div>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== description3) {
    t9 = <span className={styles.riskCardQuestionText}>{description3}</span>;
    $[18] = description3;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== icon) {
    t10 = <span className={styles.riskCardEmoji} aria-hidden="true">{icon}</span>;
    $[20] = icon;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <p className={styles.riskCardQuestion}>{t9}{t10}</p>;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t6 || $[27] !== t8) {
    t12 = <div className={styles.riskCardBody}>{t6}{t8}{t11}</div>;
    $[25] = t11;
    $[26] = t6;
    $[27] = t8;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t5) {
    t13 = <article className={styles.riskCard}>{t5}{t12}</article>;
    $[29] = t12;
    $[30] = t5;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
}
function _temp2(block) {
  return <p key={block} className={styles.riskCardStoryBlock}>{block}</p>;
}
function _temp(b) {
  return b.trim();
}